import { useQueryClient } from 'react-query';
import {
  useAuthMutation,
  useAuthQuery,
} from '../../../common/apiUtils/queryHelper';
import {
  IGetOrganizationSettingsResponse,
  IUpdateOrganizationSettings,
} from './organizationSettingsModel';
import { identity as identityConfig } from '@sitecore-ui/portal-singular';
import { env } from 'features/common/config/envConfig';

const identity = identityConfig(env);

export const useGetCurrentOrgSettings = (options?: { enabled?: boolean }) => {
  return useAuthQuery(
    'organizationSettings',
    async (axiosInstance) => {
      return axiosInstance.get<IGetOrganizationSettingsResponse>(identity.get_org_settings.url);
    },
    options,
    identity.get_org_settings.scope,
  );
};

export const useUpdateOrganizationSettingsMutation = () => {
  const queryClient = useQueryClient();

  return useAuthMutation(
    (axiosInstance) => (payload: IUpdateOrganizationSettings) => {
      return axiosInstance.patch(identity.patch_org_settings.url, payload);
    },
    {
      onSuccess: (data, variables) => {
        variables.successCb && variables.successCb();
        queryClient.invalidateQueries('organizationSettings');
      },
      onError: (data, variables) => {
        variables.errorCb && variables.errorCb();
      },
    },
  );
};
